import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query';
import { showApiErrorToast } from './errorToast';

// Show an error toast by default for any failed query/mutation (restores the AngularJS
// global $http interceptor behavior). A query/mutation opts out by setting
// `meta: { suppressErrorToast: true }` — used when the component renders its own error UI.
const toastUnlessSuppressed = (error: unknown, meta?: Record<string, unknown>) => {
  if (meta?.suppressErrorToast === true) return;
  showApiErrorToast(error);
};

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => toastUnlessSuppressed(error, query.meta),
  }),
  mutationCache: new MutationCache({
    onError: (error, _vars, _ctx, mutation) => toastUnlessSuppressed(error, mutation.options.meta),
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
